import AddComment from './AddComment.component';

export default AddComment;
